import axios from 'axios'
import { usePortalModeStore } from '@stores/usePortalModeStore'
import { msalInstance } from '@config/auth/msalConfig'
import { toApiError } from './apiError'
import { getPortalAccessToken } from './portalAccessToken'
import { getUsernameOverrideForRequest } from '@stores/useStaffOverrideStore'

const API_BASE = `${import.meta.env.VITE_SERVER_C_URL}`

const apiC = axios.create({
    baseURL: API_BASE,
})

apiC.defaults.withCredentials = usePortalModeStore.getState().hostMode === 'parent';

apiC.interceptors.request.use(async (config) => {
    const { hostMode, viewMode } = usePortalModeStore.getState();

    config.withCredentials = true;

    (config.headers as any).set?.('x-view-mode', viewMode);
    (config.headers as any).set?.('x-host-mode', hostMode);

    const token = await getPortalAccessToken(msalInstance);
    if (token) {
        (config.headers as any).Authorization = `Bearer ${token}`;
    } else {
        delete (config.headers as any).Authorization;
    }

    const override = getUsernameOverrideForRequest(config.url);
    if (override) {
        const existingParams = config.params as Record<string, unknown> | undefined;
        if (!existingParams || existingParams.usernameOverride === undefined) {
            config.params = {
                ...(existingParams ?? {}),
                usernameOverride: override,
            };
        }
        const existingData = config.data as Record<string, unknown> | undefined;
        if (existingData && typeof existingData === 'object' && !('usernameOverride' in existingData)) {
            config.data = {
                ...existingData,
                usernameOverride: override,
            };
        }
    }

    return config;
});

apiC.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(toApiError(err)),
)

export { apiC }
